<div class="card">
  <h2 *ngIf="title" class="card__title">{{ title | i18n | async }}</h2>
  <h2 *ngIf="translatedText" class="card__title">{{ translatedText }}</h2>
  <ng-content></ng-content>
</div>
